import { LanguageMenu } from '@common/components/layout/LanguageMenu';
import { Button, EmptyState } from '@ntconsult/aluma-react';
import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="flex items-center justify-end gap-1 p-4">
        <LanguageMenu />
      </header>
      <main className="grid flex-1 place-items-center p-6">
        <EmptyState
          decorator={<CircleAlert size={48} className="text-danger" aria-hidden />}
          decoratorPlacement="top"
          align="center"
          title={t('notFound.title')}
          description={t('notFound.description')}
          action={
            <Button type="button" variant="primary" onClick={() => navigate('/')}>
              {t('notFound.back')}
            </Button>
          }
        />
      </main>
    </div>
  );
}
